import { render } from "./Triagem.vue?vue&type=template&id=81453dbe"
import script from "./Triagem.vue?vue&type=script&lang=js"
export * from "./Triagem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__